import { DayJournal, Operation } from './types'

/** Retention window for trashed records, in days. */
export const TRASH_RETENTION_DAYS = 30

const DAY_MS = 24 * 60 * 60 * 1000

interface Trashable {
  deletedAt?: number | null
}

export function isTrashed(record: Trashable): boolean {
  return typeof record.deletedAt === 'number'
}

export function permanentDeleteAt(deletedAt: number): number {
  return deletedAt + TRASH_RETENTION_DAYS * DAY_MS
}

/** Whole days left before the record is deleted for good (never negative). */
export function daysLeft(deletedAt: number, now = Date.now()): number {
  const remaining = permanentDeleteAt(deletedAt) - now
  return Math.max(0, Math.ceil(remaining / DAY_MS))
}

export function isExpired(record: Trashable, now = Date.now()): boolean {
  return typeof record.deletedAt === 'number' && permanentDeleteAt(record.deletedAt) <= now
}

/** Removes trashed operations whose 30-day retention has elapsed. */
export function purgeExpired(ops: Operation[], now = Date.now()): Operation[] {
  return ops.filter((op) => !isExpired(op, now))
}

/** Removes trashed day journals whose 30-day retention has elapsed. */
export function purgeExpiredJournals(
  journals: Record<string, DayJournal>,
  now = Date.now()
): Record<string, DayJournal> {
  const kept: Record<string, DayJournal> = {}
  for (const [date, journal] of Object.entries(journals)) {
    if (!isExpired(journal, now)) kept[date] = journal
  }
  return kept
}
